import PropTypes from "prop-types";
import {css} from "@emotion/react";

const TableWidget = ({content}) => {

    const {data, label} = content;

    const tableCss = css(`
        width:100%;
        max-width: 40em;
        margin-bottom: 2em;
    `)

    const labelStyles = css(`
        font-weight: normal;    
    `)

    const tdStyles = css(`
        padding-top: 10px;
        font-weight: normal;
        > p {
            max-width: 20em;
        }
    `);

    const trStyles = css(`
        border-bottom: .5px solid black;
    `);


    const theadStyles = css(`
        border-bottom: 1px solid black;
    `);

    // we are literally mapping over a matrix of primitive values for a table here, there are no ID's whatsoever for this
    // data that arent simply 'its index', and this is an anti-pattern. In the interest of time, and because this works
    // just fine so far, i'm simply disabling the check here. For future reference: If there are any proper IDs available
    // to use as keys, use them instead of the array index.
    /* eslint-disable react/no-array-index-key */
    const headers = data[0].map((cell, key) => {
        return <th key={key} dangerouslySetInnerHTML={{__html: cell}}></th>
    })
    const body = data.slice(1).map((row, rowkey) => {
        const cells = row.map((cell, cellkey) => {
            return <td css={tdStyles} key={cellkey} dangerouslySetInnerHTML={{__html: cell}}></td>
        })
        return <tr css={trStyles} key={rowkey}>{cells}</tr>
    })
    /* eslint-enable react/no-array-index-key */

    const table = <table css={tableCss}>
        <thead css={theadStyles}>
        <tr>{headers}</tr>
        </thead>
        <tbody>{body}</tbody>
    </table>

    return <div css={tableCss}>
        {label ? <h3 css={labelStyles}> {label}</h3> : null}
        {table}
    </div>;
};

TableWidget.propTypes = {
    content: PropTypes.object,
};

export default TableWidget;
